import { FetchLookupsResponse } from '@lib/api';

import { compilePhotoUrl } from './compilePhotoUrl';

import { LookupsValue } from '../types';

export function getRestaurantLogoUrlFromLookupsResponse(
  lookupsResponse: FetchLookupsResponse,
): LookupsValue['restaurantPhotoUrl'] {
  const restaurantLogoUrlTemplate = lookupsResponse.restaurants.find(
    (restaurant) => restaurant.restaurantLogo,
  )?.restaurantLogo;

  if (!restaurantLogoUrlTemplate) {
    return null;
  }

  return compilePhotoUrl(restaurantLogoUrlTemplate);
}
